(function() {

    'use strict';

    var ItxCmsJsonCmp =  {
        bindings:{
            data:'<'
        },
        templateUrl: 'banner.component.html',
        controller: ItxCmsJsonCmpCtrl
    };
    
    ItxCmsJsonCmpCtrl.$inject = [
        'timestampSvc', 
        'ItxScreenSizeSvc',
        '$scope'
    ];

    function ItxCmsJsonCmpCtrl(
        timestampSvc, 
        ItxScreenSizeSvc,
        $scope
    ) {
        
        var _this = this;

        _this.$onInit = function(){
            if(!this.data){
                return;
            }
            _this.content = this.data.replace('<itx-cms-json-cmp>','').replace('</itx-cms-json-cmp>','');
            _this.content = JSON.parse(_this.content);
            
            if(_this.content.image){
                var path = _this.content.image.path.split('/');
                _this.image = {
                    name: path.pop(),
                    path: window.staticContent + path.join('/') + '/',
                    format: _this.content.image.format || 'jpg',
                    alignment: _this.content.image.alignment

                };
            }
            if( _this.content.texts){
           
                _this.text = {
                    title: _this.content.texts[0].text,
                    description: _this.content.texts[1].text,
                    alignment: _this.content.image.alignment === 'left' ? 'right' : 'left'
                };
                 
            }

            if (_this.content.button) {
                _this.button = {
                    text: _this.content.button.text,
                    link: joyr.utils.getCommonPageUrl('ItxGiftCardPage', false, false)
                };
            }

            if(_this.type ==='video'){
                _this.videoUrl = _this.image.path + _this.image.name + '.mp4' ;
            }

            _this.newTimestamp = '?t=' + timestampSvc.getTs();
            _this.ItxScreenSizeSvc = ItxScreenSizeSvc;
            
            _this.goToGiftCard = function (params) {
                var url = joyr.utils.getCommonPageUrl('ItxGiftCardPage', false, false);
                var path = '#/menu/';
                if(_this.ItxScreenSizeSvc.is('md,lg')){
                    path = '#/';
                }
                var urlRedirect = url + path + params;
                window.location.href = urlRedirect;
            };
        };

       
    }

    angular.module('itxApp.catalog')
    .component('banner', ItxCmsJsonCmp);

})();